var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M2 0C0.89543 0 0 0.895431 0 2V12C0 13.1046 0.895431 14 2 14H8C9.10457 14 10 13.1046 10 12V4.41421C10 4.01639 9.84196 3.63486 9.56066 3.35355L6.64645 0.43934C6.36514 0.158035 5.98361 0 5.58579 0H2ZM1 2C1 1.44772 1.44772 1 2 1H5V3.5C5 4.32843 5.67157 5 6.5 5H9V12C9 12.5523 8.55229 13 8 13H2C1.44772 13 1 12.5523 1 12V2ZM8.79289 4H6.5C6.22386 4 6 3.77614 6 3.5V1.20711L8.79289 4Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaDocument);
export default __webpack_public_path__ + "static/media/ba-document.631f3eea7b5af743c9139c0000190940.svg";
export { ForwardRef as ReactComponent };